import React, { useEffect, useMemo, useState } from "react";

/** Build full S3/CDN URLs for theme media paths from admin uploads (same keys as game HUD). */
export function useThemeIconUrls(themeData) {
  const s3Base = process.env.REACT_APP_S3_PATH || "";
  return useMemo(() => {
    const keys = ["energy", "time", "heart", "cookie", "drink", "sound"];
    const out = {};
    keys.forEach((key) => {
      const v = themeData?.[key];
      if (v == null || v === "") {
        out[key] = null;
      } else if (typeof v === "string") {
        out[key] = /^https?:\/\//i.test(v) ? v : `${s3Base}${v}`;
      } else {
        out[key] = null;
      }
    });
    return out;
  }, [themeData, s3Base]);
}

export function ThemeIconImg({ src, alt, fallback, className = "" }) {
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    setFailed(false);
  }, [src]);
  const cls = ["healthsprint-theme-icon", className].filter(Boolean).join(" ");
  if (src && !failed) {
    return (
      <img
        src={src}
        alt={alt || ""}
        className={cls}
        loading="lazy"
        decoding="async"
        onError={() => setFailed(true)}
      />
    );
  }
  return <span className={cls}>{fallback}</span>;
}
